module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_online-store_1_.a05fd7a0.png";